import { render, staticRenderFns } from "./PromotionConfigPane.vue?vue&type=template&id=60919964&scoped=true"
import script from "./PromotionConfigPane.vue?vue&type=script&lang=js"
export * from "./PromotionConfigPane.vue?vue&type=script&lang=js"
import style0 from "./PromotionConfigPane.vue?vue&type=style&index=0&id=60919964&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60919964",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60919964')) {
      api.createRecord('60919964', component.options)
    } else {
      api.reload('60919964', component.options)
    }
    module.hot.accept("./PromotionConfigPane.vue?vue&type=template&id=60919964&scoped=true", function () {
      api.rerender('60919964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/promotion/PromotionConfigPane.vue"
export default component.exports